import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions, Functions } from 'firebase/functions';
import { getStorage, FirebaseStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

console.log('Environment Check:', {
  hasApiKey: !!process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  envKeys: Object.keys(process.env).filter(key => key.startsWith('REACT_APP_FIREBASE_')),
});

// Initialize Firebase
let app: FirebaseApp;
try {
  app = initializeApp(firebaseConfig);
  console.log('Firebase app initialized with project:', firebaseConfig.projectId);
} catch (error) {
  console.error('Error initializing Firebase app:', error);
  throw error;
}

let auth: Auth | null = null;
let dbTools: Firestore;
let storage: FirebaseStorage;
let functions: Functions;

try {
  // Connect to the "tools" Firestore database.
  dbTools = getFirestore(app, 'tools');

  // Optional: enable persistence using the new local cache API.
  // Note: if you need to pass extra settings, use initializeFirestore first, then override with getFirestore if needed.
  // For many projects, the basic getFirestore call is sufficient.

  storage = getStorage(app);
  functions = getFunctions(app);

  console.log('Firebase services initialized:', {
    dbTools: !!dbTools,
    storage: !!storage,
    functions: !!functions
  });
} catch (error) {
  console.error('Error initializing Firebase services:', error);
  throw error;
}

export const initializeAuth = () => {
  if (!auth) {
    auth = getAuth(app);
    console.log('Firebase auth initialized');
  }
  return auth;
};

export { auth, dbTools, storage, functions };
export default app;